'use strict';

export class StoreHours {
    run () {
        var daysOfTheWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        this.currentDate = new Date();
        this.today = daysOfTheWeek[this.currentDate.getDay()];
        this.tomorrow = daysOfTheWeek[this.currentDate.getDay() + 1] || daysOfTheWeek[0];
        this.storeHoursList = $('.store-hours-list li[data-name="' + this.today + '"]:not(.active)');

        this.init();
        this.addEventListeners();
    }

    init () {
        var _self = this;

        this.storeHoursList.each(function (_idx, storeHours) {
            $(storeHours).addClass('active');

            var currentStore = $(storeHours).parents('.store-hours');
            var nextPhase = _self.getStoreHoursPhase(storeHours, currentStore);

            // Check for temporarily closed store
            var isTemporarilyClosed = currentStore.data('temporarily-closed');
            var reopDate = currentStore.data('reopening-date') ? currentStore.data('reopening-date').split('-') : false; // Format: yyyy-mm-dd
            var reopeningDate = reopDate ? new Date(reopDate[0], (reopDate[1] - 1), reopDate[2]) : false;

            if (isTemporarilyClosed) {
                if (!reopeningDate) {
                    currentStore.find('.store-hours-temporarily-closed').removeClass('hidden');
                } else if (_self.currentDate < reopeningDate) {
                    currentStore.find('.store-hours-temporarily-closed').removeClass('hidden');
                    currentStore.find('.store-hours-reopens-on').removeClass('hidden');
                    nextPhase = reopeningDate.toLocaleDateString($('html').attr('lang'));
                } else {
                    isTemporarilyClosed = false;
                }
            }

            if (!isTemporarilyClosed) {
                if (_self.isStoreOpen(storeHours)) {
                    currentStore.find('.store-hours-open').removeClass('hidden');
                    currentStore.find('.store-hours-open-until').removeClass('hidden');
                } else {
                    currentStore.find('.store-hours-closed').removeClass('hidden');

                    if (nextPhase) {
                        currentStore.find('.store-hours-reopens-at').removeClass('hidden');
                    }
                }
            }

            currentStore.find('.js-store-next-phase').html(nextPhase);
        });
    }

    addEventListeners () {
        // Toggle store hours list dropdown
        $('.js-toggle-store-hours').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).find('.toggle-store-hours-dropdown').toggleClass('flip');
            $(this).closest('.store-hours').find('.store-hours-list').toggleClass('hidden');
        });
    }

    /**
     * Get next store hours phase to be appended to "open until" or "re-opens at"
     * @param {object} storeHours
     * @param {object} store
     * @returns {string} return next store hours phase
     */
    getStoreHoursPhase (storeHours, store) {
        var phases = $(storeHours).data('first-phase') ? $(storeHours).data('phases').split(' ; ') : false;
        var tomorrowFirstPhase = $('[data-store-id="' + store.data('store-id') + '"] li[data-name="' + this.tomorrow + '"]').data('first-phase');
        var currentPhase = -1;

        // Loop through x phases
        for (var i = 0; i < phases.length; i++) {
            var phase = phases[i].split('-'); // Split start and end time
            var startPhase = phase[0].split(':'); // Split hours and mins for

            var startDate = new Date(this.currentDate.getTime()); // Create Date object based on currentDate
            startDate.setHours(startPhase[0]); // Set hours and mins based on
            startDate.setMinutes(startPhase[1]);

            // Check if today occured a phase
            if (startDate <= this.currentDate) {
                currentPhase = i;
            }
        }

        var nextPhase;

        if (this.isStoreOpen(storeHours)) {
            // If store is open returns current phase end time
            nextPhase = phases[currentPhase].split('-')[1];
        } else if (currentPhase < phases.length - 1) {
            // Store closed, show next phase start time if available
            nextPhase = phases[currentPhase + 1].split('-')[0];
        } else if (tomorrowFirstPhase) {
            var tomorrowStartTime = tomorrowFirstPhase.split(':');
            if (phases || (this.currentDate.getHours() >= tomorrowStartTime[0] && this.currentDate.getMinutes() >= tomorrowStartTime[1])) {
                // End of phases show next day start time if available
                nextPhase = tomorrowFirstPhase;
            }
        } else {
            // End of phases and closed next day
            nextPhase = false;
        }

        return nextPhase || false;
    }

    /**
     * Check if store is open in a specific date
     * @param {object} storeHours
     * @returns {boolean} return next phase if open, otherwise false
     */
    isStoreOpen (storeHours) {
        var phases = $(storeHours).data('phases') ? $(storeHours).data('phases').split(' ; ') : false;
        var isStoreOpen = false;

        // Check if today has store hours
        if (!phases) {
            return false;
        }

        // Loop through x phases
        for (var i = 0; i < phases.length; i++) {
            // Split phases to start and end
            var phase = phases[i].split('-');
            // Split time to hours and minutes
            var startPhase = phase[0].split(':');
            var endPhase = phase[1] ? phase[1].split(':') : '';

            // Create Date object based on currentDate and fill with new data
            var startDate = new Date(this.currentDate.getTime());
            startDate.setHours(startPhase[0]);
            startDate.setMinutes(startPhase[1]);

            var endDate = new Date(this.currentDate.getTime());
            // If start time hour is greater than end time hour (e.g. 16:00-03:00) the end time must be valued as the day after
            if (startPhase[0] > endPhase[0]) {
                endDate.setDate(endDate.getDate() + 1);
            }

            endDate.setHours(endPhase[0]);
            endDate.setMinutes(endPhase[1]);

            // Check if currentDate is between start and end time
            if (startDate <= this.currentDate && endDate > this.currentDate) {
                isStoreOpen = true;
            }
        }

        return isStoreOpen;
    }
}

const storeHoursObject = new StoreHours();
export default storeHoursObject;
